import { WindowTitle } from "@dashboard/components/WindowTitle";
import { useIntl } from "react-intl";

import { FeedbackList } from "./FeedbackList";
import { feedbackMessages } from "./messages";

const FeedbackSection = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(feedbackMessages.title)} />
      <FeedbackList />
    </>
  );
};

export default FeedbackSection;
